import store from '@/store'

export default async () => {
  store.dispatch('check')
}



// WEBPACK FOOTER //
// ./src/services/auth/check.js